import { render, staticRenderFns } from "./DropdownFilterPromotionTypes.vue?vue&type=template&id=0336e4e2&"
import script from "./DropdownFilterPromotionTypes.vue?vue&type=script&lang=js&"
export * from "./DropdownFilterPromotionTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0336e4e2')) {
      api.createRecord('0336e4e2', component.options)
    } else {
      api.reload('0336e4e2', component.options)
    }
    module.hot.accept("./DropdownFilterPromotionTypes.vue?vue&type=template&id=0336e4e2&", function () {
      api.rerender('0336e4e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/DropdownFilterPromotionTypes.vue"
export default component.exports